import { ComponentPropsWithoutRef, useEffect, useRef } from 'react';
import * as Styled from 'components/iframe/styled';

interface IframeProps extends ComponentPropsWithoutRef<'iframe'> {
    data?: string;
    url?: string;
}

const Iframe = ({ data, url, ...iframeProps }: IframeProps) => {
    const ref = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        if (ref.current) {
            const src = data ? `data:text/html;charset=utf-8, ${escape(data)}` : url;
            if (src) {
                ref.current.src = src;
            }
        }
    }, [data, url]);

    return <Styled.Iframe ref={ref} {...iframeProps} />;
};

const Root = Iframe;

export {
    Iframe,
    //
    Root,
};
export type { IframeProps };
